





























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import moment from "moment";
import { User } from "@/types";
import Callback from "@/components/Call/Callback.vue";
import LeadPanel from "@/components/Lead/LeadPanel.vue";
import logger from "../configs/logger";
import { collections } from "@/configs/firebase";

@Component({ components: { LeadPanel, Callback } })
export default class UpcomingCallback extends Vue {
  @Action("unbindUpcomingCallbacks") unbindUpcomingCallbacks!: Function;
  @Action("bindUpcomingCallbacks") bindUpcomingCallbacks!: Function;
  @State("upcomingCallbacks") upcomingCallbacks!: [];
  @State("user") user!: User;

  activeLeadId: string = "";
  dialog = false;
  todos: any[] = [];

  @Watch("upcomingCallbacks")
  onUpcomingCallbacks(callbacks: any[]) {
    this.todos = callbacks.map((item: any) => ({
      time: this.formatTime(item.callback_time),
      leadName: item.lead_name,
      callback: {
        leadKey: item.lead_key
      },
      view: { leadId: item.lead_key.split("/")[1] },
      remove: { id: item.id }
    }));
  }

  created() {
    this.bindUpcomingCallbacks();
  }

  beforeDestoryed() {
    this.unbindUpcomingCallbacks();
  }

  headers = [
    { text: "Time", value: "time" },
    { text: "Lead Name", value: "leadName" },
    { text: "Call Back", value: "callback" },
    { text: "View Lead", value: "view" },
    { text: "Remove", value: "remove" }
  ];

  handleViewLead(leadId: string) {
    this.activeLeadId = leadId;
    this.dialog = true;
  }

  isPassed(time: any) {
    return moment().unix() >= time.seconds;
  }

  formatTime(time: any) {
    return moment
      .unix(time.seconds)
      .local()
      .calendar();
  }

  async deleteCallback(id: string) {
    try {
      const confirmed = window.confirm(
        "Are you sure you want to delete this callback?"
      );
      if (confirmed) {
        await collections.upcomingCallbacks.doc(id).delete();
      }
    } catch (err) {
      logger("log", "callback delete error:", err);
    }
  }
}
